import React, { useEffect, useState, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"
import { isEmpty } from "lodash"

import { Button, Card, CardBody, CardTitle, Alert, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

import { consoleSignupList } from "store/actions"

import { dateHumanReadable } from "common/global/functions.js"

import { String, Status, View, Recourse, Active, Date,} from "./list-cols"

import TableContainer from "./table-container"
import ActionModal from "./actionModal/"

const SignupList = props => {
    
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(consoleSignupList())
  }, [dispatch])

  const selectConsole = state => state.console
  const ConsoleProperties = createSelector(selectConsole, console => ({
    loading: console.loading,
    signuplist: console.signupList,
    signupListError : console.signupListError,
  }))
  
  const { signupList : list, signupListError : error, loading } = useSelector(selectConsole)

  const [collection, setCollection] = useState([])
  const [personalLinkActionModal, setPersonalLinkActionModal] = useState(false)
  const [id, setId] = useState(false)
  

  useEffect(() => {
    if (!_.isEmpty(list)) {

      setCollection(
        _.map(list, function (l, index) {
          return {
            ...l,
            id: l.signup_id,
          }
        })
      )
    }
  }, [list])

  const toggleViewActionModal = id => {
    setPersonalLinkActionModal(!personalLinkActionModal)
    setId(id ? id : false)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: false,
        disableFilters: true,
        isHidden: false,
        Cell: cellProps => {
          return <String {...cellProps} />
        },
      },
      {
        Header: "Date",
        accessor: "created",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <Date {...cellProps} />
        },
      },
      {
        Header: "Applicant Type",
        accessor: "applicant_type",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <String {...cellProps} />
        },
      },
      {
        Header: "Name",
        accessor: "applicant",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <String {...cellProps} />
        },
      },
      {
        Header: "Co-Signer",
        accessor: "coapplicant",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <String {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "status",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <Status {...cellProps} />
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        accessor: "url",
        Cell: cellProps => {
          return (
            <Button
              type="button"
              color="light-subtle"
              className="btn-sm"
              onClick={() =>
                toggleViewActionModal(cellProps.row.values.id)
              }
            >
              <i className="bx bx-dots-vertical-rounded font-size-16 align-middle me-2"></i>{" "}
            </Button>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">&nbsp;</div>
          {error ? (
            <Alert color="danger">{error}</Alert>
          ) : (
              !_.isEmpty(collection) ? (
                <>
                  <ActionModal
                    isOpen={personalLinkActionModal}
                    toggle={toggleViewActionModal}
                    collection={collection}
                    id={id}
                  />

                  <TableContainer
                    columns={columns.filter((col) => !col.isHidden)}
                    data={collection}
                    isGlobalFilter={true}
                    isAddOptionsLink={false}
                    addOptionsLinkTitle={false}
                    handleAddOptionsLink={"/merchants/vetting/new"}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    customPageSize={10}
                    //pagination="pagination pagination-rounded justify-content-end mb-2"
                    tableClass="align-middle table-nowrap table-check table"
                    theadClass="table-light"
                    paginationDiv="col-12"
                    pagination="justify-content-center pagination pagination-rounded"
                    isShowingPageLength={true}
                  />


                </>

              ) : (
                <Row className="icon-demo-content">
                  <Col xl="12" lg="12" sm="12">
                  <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                  <i className="mdi mdi-database-off mdi-48px"></i> Empty List
                  </CardTitle>
                  </CardBody>
                  </Card>
                  </Col>
                </Row>
              )
            )
          }
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
/*
List.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}
  */

export default withRouter(SignupList)
